import styled from "styled-components";

export const Container = styled.section`
    width: 100%;    
    /* height: 100vh;   */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #58626c;
    padding: 0 6rem;

    h1 {
        font-family: 'Great Vibes', sans-serif;
        font-size: 4rem;
        font-weight: 200;
    }

    h2 {
        max-width: 500px;
        margin: 20px 30px;
        font-family: 'Josefin Slab', sans-serif;
        text-align: center;
        font-weight: 200;
        font-size: 2rem;
    }

    div.image-gallery {
        width: 75%;
    }

    @media (max-width: 1020px) {
        div.image-gallery {
            width: 100%;
        }
    }

    @media (max-width: 870px) {
        padding: 0 3rem;        
    }

    @media (max-width: 770px) {
        padding: 0 1rem;
    }

    @media (max-width: 500px) {
        h1 {
            font-size: 3rem;
        }
        h2 {
            font-size: 1.7rem;
            margin: 20px 0px;
        }
    }

`